import { render } from "./WhatsAppChat.vue?vue&type=template&id=7b8bf278&scoped=true&ts=true"
import script from "./WhatsAppChat.vue?vue&type=script&lang=ts"
export * from "./WhatsAppChat.vue?vue&type=script&lang=ts"

import "./WhatsAppChat.vue?vue&type=style&index=0&id=7b8bf278&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b8bf278"]])

export default __exports__